import {
  ListItemIcon as MuiListItemIcon,
  type ListItemIconProps as MuiListItemIconProps,
  type Theme,
} from "@mui/material";

import { CbhIcon, type IconType } from "../CbhIcon";

interface ListItemIconWithIconProps extends Omit<MuiListItemIconProps, "color" | "children"> {
  color?: (theme: Theme) => string;
  iconType: IconType;
}

type ListItemIconWithChildrenProps = Omit<MuiListItemIconProps, "color">;

export type ListItemIconProps = ListItemIconWithIconProps | ListItemIconWithChildrenProps;

export function ListItemIcon(props: ListItemIconProps) {
  if ("iconType" in props) {
    const { iconType, color, ...restProps } = props;
    return (
      <MuiListItemIcon {...restProps}>
        <CbhIcon type={iconType} color={color} size="medium" />
      </MuiListItemIcon>
    );
  }

  return <MuiListItemIcon {...props} />;
}
